<template>
  <v-container
    fluid
  >
    Forgot pass
  </v-container>
</template>

<script>
export default {
  name: "neoparent-forgot-pass",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="scss"></style>
